var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRupee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.84064 2.71845V2.94563H9.72301V4.27627H7.74328C7.62428 5.00109 7.3971 5.57986 7.06173 6.01259C6.73719 6.4345 6.27201 6.74281 5.66619 6.93754C5.06037 7.12145 4.27605 7.21341 3.31323 7.21341V8.23572C3.31323 8.83072 3.43764 9.30131 3.68646 9.6475C3.9461 9.99368 4.37882 10.1668 4.98464 10.1668C6.0881 10.1668 6.63982 9.54472 6.63982 8.30063H8.34369C8.33287 9.39327 8.03537 10.2209 7.45119 10.7834C6.87782 11.3351 6.04483 11.611 4.95219 11.611C3.85955 11.611 3.02114 11.3081 2.43696 10.7023C1.8636 10.0965 1.57692 9.24722 1.57692 8.15459V5.93145C2.77773 5.93145 3.65942 5.899 4.22196 5.83409C4.78451 5.75836 5.20101 5.6069 5.47146 5.37972C5.75273 5.15254 5.93664 4.78472 6.02319 4.27627H0.89537V2.94563H6.10432V2.71845V1.5014H0.89537V0.154541H9.72301V1.5014H7.84064V2.71845Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/rupee.c6f64286a3f4331a320ea4c0a74eda93.svg";
export { ForwardRef as ReactComponent };